"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedItem = void 0;
var FeedItem = function () {
  function FeedItem() {}
  FeedItem.getAttributeTypeMap = function () {
    return FeedItem.attributeTypeMap;
  };
  FeedItem.discriminator = undefined;
  FeedItem.attributeTypeMap = [{
    "name": "id",
    "baseName": "id",
    "type": "string"
  }, {
    "name": "ts",
    "baseName": "ts",
    "type": "number"
  }, {
    "name": "source",
    "baseName": "source",
    "type": "FeedItem.SourceEnum"
  }, {
    "name": "url",
    "baseName": "url",
    "type": "string"
  }, {
    "name": "media",
    "baseName": "media",
    "type": "Array<FeedItemMedia>"
  }, {
    "name": "content",
    "baseName": "content",
    "type": "string"
  }];
  return FeedItem;
}();
exports.FeedItem = FeedItem;
(function (FeedItem) {
  var SourceEnum;
  (function (SourceEnum) {
    SourceEnum[SourceEnum["Twitter"] = 'twitter'] = "Twitter";
    SourceEnum[SourceEnum["Instagram"] = 'instagram'] = "Instagram";
    SourceEnum[SourceEnum["Blogger"] = 'blogger'] = "Blogger";
    SourceEnum[SourceEnum["Soundcloud"] = 'soundcloud'] = "Soundcloud";
    SourceEnum[SourceEnum["Swarm"] = 'swarm'] = "Swarm";
    SourceEnum[SourceEnum["Deviantart"] = 'deviantart'] = "Deviantart";
  })(SourceEnum = FeedItem.SourceEnum || (FeedItem.SourceEnum = {}));
})(FeedItem = exports.FeedItem || (exports.FeedItem = {}));
exports.FeedItem = FeedItem;